import React, { useState, useEffect } from 'react';
import giftIcon from '../assets/gift_icon.png';
import userIcon from '../assets/user_blue.png';
import paragraphIcon from '../assets/paragraph_icon.png';
import checkMarkIcon from '../assets/check_mark_yellow.png';
import yourStory from '../assets/your_story_mockup.png';

import { loadStripe } from "@stripe/stripe-js";
import { Elements, PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";

function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Cookie like "csrftoken=<value>"
      if (cookie.substring(0, name.length + 1) === (name + "=")) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
      }
      }
  }
  return cookieValue;
}

export default function GiveGift(props) {
  // Only scroll to top on initial mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  // Gift ID to be used in payment success url.
  const [referenceNumber, setReferenceNumber] = useState('');

  // Simple error state
  const [errors, setErrors] = useState({});
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [clientSecret, setClientSecret] = useState("");
  const stripePromise = loadStripe("pk_test_51Q6ELM15lp4XHXAAeFmiYYTppuOzIHwD8gjxAhMnMentcum9SlvvIGpdrHlDCEW1bdXxvPLU9FZdVwdhD6rxv6EP00Q1sk5JZN");

  // Add a state variable to track message length
  const [messageLength, setMessageLength] = useState(0);

  const [isDetailsExpanded, setIsDetailsExpanded] = useState(false);
  
  // Define maximum lengths for different field types
  const maxLengths = {
    name: 50,        // For first/last names
    email: 100,      // For email addresses
    message: 500,    // For gift messages
    giftFrom: 100    // For "gift from" field
  };
  
  // Handle input changes with length validation
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Determine which max length to apply
    let maxLength;
    if (name === 'first-name' || name === 'last-name' || 
        name === 'recipient-first-name' || name === 'recipient-last-name') {
      maxLength = maxLengths.name;
    } else if (name === 'email') {
      maxLength = maxLengths.email;
    } else if (name === 'gift-message') {
      maxLength = maxLengths.message;
      // Update message length state
      setMessageLength(value.length);
    } else if (name === 'gift-from') {
      maxLength = maxLengths.giftFrom;
    }
    
    // If value exceeds max length, truncate it
    if (maxLength && value.length > maxLength) {
      e.target.value = value.slice(0, maxLength);
      
      // If this was the message field, update the length state again
      if (name === 'gift-message') {
        setMessageLength(maxLength);
      }
    }
  };

  // Simple form validation on submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const newErrors = {};
    
    // Check required fields
    const requiredFields = [
      'first-name', 
      'last-name', 
      'email', 
      'recipient-first-name', 
      'recipient-last-name', 
      'gift-message', 
      'gift-from'
    ];
    
    requiredFields.forEach(field => {
      if (!form[field].value.trim()) {
        newErrors[field] = 'required';
      }
    });
    
    // Check email format
    if (form['email'].value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form['email'].value)) {
      newErrors['email'] = 'not a valid email address';
    }

    setErrors(newErrors);

    // If no errors, submit the form and show payment form
    if (Object.keys(newErrors).length === 0) {
      try {
        // Create gift object
        const giftData = {
          first_name: form['first-name'].value,
          last_name: form['last-name'].value,
          email: form['email'].value,
          recipient_first_name: form['recipient-first-name'].value,
          recipient_last_name: form['recipient-last-name'].value,
          gift_message: form['gift-message'].value || '',
          gift_from: form['gift-from'].value,
        };

        console.log(giftData);

        const csrfToken = getCookie('csrftoken');

        // Send to your API
        const response = await fetch('/api/create_gift', {
          method: 'POST',
          credentials: 'include',  // Important for cookies
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken,
          },
          body: JSON.stringify(giftData),
        });
        
        const createdGiftData = await response.json();
        setReferenceNumber(createdGiftData.reference_number);

        if (createdGiftData.success) {
          // Then create a payment intent for this gift
          const paymentResponse = await fetch("/api/create_payment_intent", {
            method: "POST",
            credentials: 'include',  // Important for cookies
            headers: { 
              "Content-Type": "application/json",
              'X-CSRFToken': csrfToken,
            },
            body: JSON.stringify({ 
              amount: 24900,
              item_type: 'gift',
              item_id: createdGiftData.gift_id,
              reference_number: createdGiftData.reference_number,
            }),
          });
          
          const paymentData = await paymentResponse.json();
          
          if (paymentData.clientSecret) {
            setClientSecret(paymentData.clientSecret);
            setShowPaymentForm(true);
          }
        }
      } catch (error) {
        console.error('Error:', error);
        // Handle error (show message to user)
      }
    } else {
      setErrors(newErrors);
    }
  };

  function rightPane() {
    return (
        <>
        <div className="give-gift-price-section">
          <h3 className="give-gift-price-title">Gift Order Summary</h3>
          <div className="give-gift-order-details">
            <div className="give-gift-price-amount-container">
              <img src={paragraphIcon} className="give-gift-price-paragraph-icon"/>
              <div>
                <p className="give-gift-product-description">One Living Legend Chapter</p>
                <p className="give-gift-price-amount">$249</p>
              </div>
              <img src={yourStory} className="give-gift-price-your-story-mockup"/>
            </div>
            <div className="give-gift-order-details-count">x1</div>
          </div>
          <div className="give-gift-price-total-container">
            <p className="give-gift-price-total-text">Total Due</p>
            <p className="give-gift-price-total-amount">$249</p>
          </div>
        </div>
        <h3 className="give-gift-form-title">Next Steps</h3>
        <p className="give-gift-form-subtitle left">Once you check out, the following will happen.</p>
        <div 
          className={`expandable-container ${isDetailsExpanded ? "" : "collapsed"}`}
          onClick={() => setIsDetailsExpanded(!isDetailsExpanded)}
        >
          <div className={`expandable-container-overlay ${isDetailsExpanded ? "" : "collapsed"}`}></div>
          <ol>
            <li>First we'll email you the gift certificate for you to share with the recipient.</li>
            <li>Once they redeem the gift, they'll pick a topic and join a 1-hour Zoom interview.</li>
            <li>After the interview, we'll write their chapter and send them a draft within a week.</li>
            <li>We'll go through one round of revisions with them and then send them a finalized PDF and an audio version.</li>
            <li>Two hardcover booklets arrive 2-3 weeks later.</li>
          </ol>
          <h3 className="give-gift-form-title">Get in touch</h3>
          <p className="give-gift-form-subtitle left">If you have any questions at all, just reach out!</p>
          <ul>
            <li className="give-gift-form-email">Email us at <a className="give-gift-form-email-link" href="mailto:hello@yourlivinglegend.com">hello@yourlivinglegend.com</a></li>
            <li className="give-gift-form-phone">Call us at (323) 484-2354</li>
          </ul>
        </div>
        <button 
          className="expandable-container-button" 
          onClick={() => setIsDetailsExpanded(!isDetailsExpanded)}
        >
          {isDetailsExpanded ? "Show Less" : "Show More"}
        </button>
      </>
    )
  }
  
  function getGiftForm() {
    return (
      <div className="give-gift-container">
        <h1 className="give-gift-title">What a Wonderful Gift!</h1>
        <h2 className="give-gift-subtitle">
          You're about to give the gift of a lifetime to someone you love.
        </h2>
        <div className="give-gift-two-pane-container">
          <div className="give-gift-two-pane-left-container">
            <form onSubmit={handleSubmit} noValidate>
              <div className="give-gift-form-instructions-container">
                <img src={userIcon} alt="Gift Icon" className="give-gift-form-instructions-container-icon" />
                <div className="give-gift-form-instructions-container-text">
                  <h3 className="give-gift-form-title">Your Information</h3>
                  <p className="give-gift-form-subtitle">First we need to know a little bit about you.</p>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="first-name">
                    First Name {errors['first-name'] && <span className="error-text">({errors['first-name']})</span>}
                  </label>
                  <input 
                    type="text" 
                    id="first-name" 
                    name="first-name" 
                    placeholder="First Name" 
                    maxLength={maxLengths.name}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="last-name">
                    Last Name {errors['last-name'] && <span className="error-text">({errors['last-name']})</span>}
                  </label>
                  <input 
                    type="text" 
                    id="last-name" 
                    name="last-name" 
                    placeholder="Last Name" 
                    maxLength={maxLengths.name}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">
                    Email {errors['email'] && <span className="error-text">({errors['email']})</span>}
                  </label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email" 
                    placeholder="Email" 
                    maxLength={maxLengths.email}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            
              <div className="give-gift-form-separator">
                <div className="give-gift-form-separator-line"></div>
              </div>

              <div className="give-gift-form-instructions-container">
                <img src={giftIcon} alt="Gift Icon" className="give-gift-form-instructions-container-icon" />
                <div className="give-gift-form-instructions-container-text">
                  <h3 className="give-gift-form-title">Recipient Information</h3>
                  <p className="give-gift-form-subtitle">Now we need to know a little bit about the recipient. Who is it for, who is it from, and what would you like to tell them about their gift?</p>
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="recipient-first-name">
                    Recipient First Name {errors['recipient-first-name'] && <span className="error-text">({errors['recipient-first-name']})</span>}
                  </label>
                  <input 
                    type="text" 
                    id="recipient-first-name" 
                    name="recipient-first-name" 
                    placeholder="Recipient First Name" 
                    maxLength={maxLengths.name}
                    onChange={handleInputChange}
                  />
                </div>
                
                <div className="form-group">
                  <label htmlFor="recipient-last-name">
                    Recipient Last Name {errors['recipient-last-name'] && <span className="error-text">({errors['recipient-last-name']})</span>}
                  </label>
                  <input 
                    type="text" 
                    id="recipient-last-name" 
                    name="recipient-last-name" 
                    placeholder="Recipient Last Name" 
                    maxLength={maxLengths.name}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="gift-message">
                    Gift Message {errors['gift-message'] && <span className="error-text">({errors['gift-message']})</span>}
                    <span className="character-count">{messageLength}/{maxLengths.message}</span>
                  </label>
                  <textarea 
                    id="gift-message" 
                    name="gift-message" 
                    placeholder="Gift Message" 
                    rows={5}
                    maxLength={maxLengths.message}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <div>
                <div className="form-group">
                  <label htmlFor="gift-from">
                    Who should we say the gift is from? {errors['gift-from'] && <span className="error-text">({errors['gift-from']})</span>}
                  </label>
                  <input 
                    type="text" 
                    id="gift-from" 
                    name="gift-from" 
                    placeholder="Your Name / Your Family's Name / ..." 
                    maxLength={maxLengths.giftFrom}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <button className="give-gift-form-button">Continue to Payment</button>
            </form>
          </div>
          <div className="give-gift-two-pane-right-container">
            {rightPane()}
          </div>
        </div>
      </div>
    )
  };

  // Payment form component - defined outside of conditional rendering
  const CheckoutForm = () => {
    const stripe = useStripe();
    const elements = useElements();
    const [paymentError, setPaymentError] = useState("");
    const [processing, setProcessing] = useState(false);
    
    const handlePaymentSubmit = async (e) => {
      e.preventDefault();
      
      if (!stripe || !elements) {
        return;
      }
      
      setProcessing(true);
      
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          // This is the URL that Stripe will redirect to after the payment is successful
          // only for so-called 3D payments, common in Europe. Otherwise, the flow follows
          // the other code below where we explicitly call navigateToPaymentSuccess().          
          return_url: window.location.origin + "/payment_success?reference_number=" + referenceNumber,
        },
        redirect: "if_required"
      });
      
      if (error) {
        setPaymentError(error.message);
        setProcessing(false);
      } else if (paymentIntent && paymentIntent.status === "succeeded") {
        // Handle successful payment
        console.log("Payment successful");
        console.log(paymentIntent);
        props.navigateToPaymentSuccess(referenceNumber);
      }
    };

    return (
        <form onSubmit={handlePaymentSubmit} className="payment-form">
          <h2>Complete Your Payment</h2>
          <PaymentElement />
          {paymentError && <div className="payment-error">{paymentError}</div>}
          
          <div className="tos-container">
            <label className="tos-label">
              <span className="tos-text">
                By clicking "Pay Now" below, you agree to Living Legend's <a href="/terms-of-service" className="tos-link">Terms of Service</a> and <a href="/privacy-policy" className="tos-link">Privacy Policy</a>.
              </span>
            </label>
          </div>
          
          <button 
            type="submit" 
            disabled={!stripe || processing} 
            className="payment-button"
          >
            {processing ? "Processing..." : "Pay Now"}
          </button>
        </form>
    )
  };

  function getPaymentForm() {
    return (
      <div className="give-gift-container">
        <h1 className="give-gift-title">What a Wonderful Gift!</h1>
        <h2 className="give-gift-subtitle">
          You're about to give the gift of a lifetime to someone you love.
        </h2>
        <div className="give-gift-two-pane-container">
          <div className="give-gift-two-pane-left-container">
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <CheckoutForm />
            </Elements>
          </div>
          <div className="give-gift-two-pane-right-container">
            {rightPane()}
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className="give-gift-container">
      {showPaymentForm ? getPaymentForm() : getGiftForm()}
    </div>
  );
}